import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-thirty-four',
  templateUrl: './home-thirty-four.component.html',
  styleUrls: ['./home-thirty-four.component.scss']
})
export class HomeThirtyFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
